/**
 * @param {Number} number
 * @param {'ceil'|'floor'|'round'} type
 * @param {Number} decimalPlaces
 * @returns {String}
 */
export default function roundToDecimal(number, type = 'ceil', decimalPlaces = 2) {
  if ((number < 0.01) & (number !== 0)) {
    decimalPlaces = 3
  }

  const multiplier = 10 ** decimalPlaces
  return (Math[type](+(number * multiplier).toFixed(3)) / multiplier).toFixed(decimalPlaces)
}
